import type { ImportMetaEnv } from 'vite/client'

type RuntimeEnvRecord = Record<string, string | boolean | undefined>

declare global {
  interface Window {
    __ENV__?: RuntimeEnvRecord
  }
}

const getRuntimeEnv = (): RuntimeEnvRecord => {
  if (typeof window === 'undefined') {
    return {}
  }
  return window.__ENV__ || {}
}

type ImportMetaEnvType = ImportMetaEnv & RuntimeEnvRecord

export const env = new Proxy(import.meta.env, {
  get(target: ImportMetaEnvType, prop: string) {
    const runtimeEnv = getRuntimeEnv()
    if (prop in runtimeEnv && runtimeEnv[prop] !== undefined) {
      return runtimeEnv[prop]
    }
    return target[prop as keyof ImportMetaEnvType]
  },
}) as ImportMetaEnvType

export const getEnvVar = (
  key: keyof ImportMetaEnvType | string,
  fallback: string | undefined = undefined
): string | undefined => {
  const value = env[key as keyof ImportMetaEnvType]
  if (typeof value === 'string') {
    return value
  }
  if (typeof value === 'boolean') {
    return value.toString()
  }
  return fallback
}
